import React, { useEffect, useState } from 'react';
import { Modal, Box, Typography, IconButton, Button, Stack, TextField, FormControl, InputLabel } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { toast } from 'react-toastify';
import WhatsappApiFunctions from '../../API/whatsapp';

const phoneUtil = PhoneNumberUtil.getInstance();

const style = {
  position: 'absolute',
  top: '50px',
  left: '50%',
  transform: 'translateX(-50%)',
  width: 600,
  height: 'max-content',
  maxHeight: '95vh',
  maxWidth: '90vw',
  //   overflowY: 'scroll',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: '12px',
};

const TestUserModal = ({ eventKey, paramsOfSelectedTemplate, inputString }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [selectedColumn, setSelectedColumn] = useState({});
  const isButtonDisabled =
    paramsOfSelectedTemplate?.length > 0
      ? Object.values(formData ?? {}).some((val) => (typeof val === 'string' ? !val.trim() : val == null))
      : true;

  // const { name, phoneNumber, category, timing } = formData;
  const [isPhoneValid, setIsPhoneValid] = useState(true);
  console.log(paramsOfSelectedTemplate);

  const handleChange = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    // setSelectedColumn(column);
    // setSelectedColumn((prev) => ({ ...prev, [name]: value }));
    // Validate phone number
    if (name === 'Number') {
      try {
        const phoneNumber = phoneUtil.parse(value, 'IN'); // Change 'IN' as needed
        setIsPhoneValid(phoneUtil.isValidNumber(phoneNumber));
      } catch (error) {
        setIsPhoneValid(false);
      }
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  const handleSubmitModal = async () => {
    if (isPhoneValid) {
      try {
        const response = await WhatsappApiFunctions.singleTestNumber(eventKey, formData);
        // if (response.Status === 1) {
        console.log('sucessfully submitted');
        setFormData({});
        toast.success('Message sent sucessfully', {
          position: 'top-right',
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
        });
        // }
      } catch (e) {
        console.error('Error submitting form:', e);
      }
      // if (response.Status === 1) {
      //   console.log('sucessfully submitted');
      //   setFormData({});
      //   toast.success('Message sent sucessfully', {
      //     position: 'top-right',
      //     autoClose: 2000,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: false,
      //     progress: undefined,
      //   });
      // }
      console.log('Form Submitted:', formData);
      setIsOpen(false);
    }
  };
  useEffect(() => {
    if (inputString > 0) {
      const result = inputString?.split(',').reduce((acc, key) => {
        acc[key] = '';
        return acc;
      }, {});
      setSelectedColumn(result);
    }
  }, [inputString]);

  return (
    <Stack>
      <Button
        variant="contained"
        disabled={!eventKey}
        onClick={() => setIsOpen(true)}
        size="large"
        sx={{
          backgroundColor: '#9f1d21',
          color: '#ffffff',
          '&:hover': {
            backgroundColor: '#e3272c',
          },
          '&:disabled': {
            backgroundColor: '#f4aac9',
            color: '#ffffff',
          },
        }}
      >
        Test Message
      </Button>
      <Modal open={isOpen} onClose={handleCloseModal} aria-labelledby="modal-modal-title">
        <Box sx={style}>
          <Stack direction="row" justifyContent="space-between" mb={4}>
            <Typography variant="h6">User Details</Typography>
            <IconButton onClick={handleCloseModal} sx={{ width: '20px', height: '20px' }}>
              <CloseIcon />
            </IconButton>
          </Stack>

          {/* Input Fields */}
          <Stack spacing={2}>
            {/* <TextField
              label="Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              fullWidth
              variant="outlined"
            />
            <TextField
              label="Phone Number"
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleChange}
              fullWidth
              type="number"
              variant="outlined"
              error={!isPhoneValid}
              helperText={!isPhoneValid ? 'Invalid phone number' : ''}
            />
            <TextField
              label="Category"
              name="category"
              value={formData.category}
              onChange={handleChange}
              fullWidth
              variant="outlined"
            />
            <TextField
              label="Timing"
              name="timing"
              value={formData.timing}
              onChange={handleChange}
              fullWidth
              variant="outlined"
            /> */}
          </Stack>

          {paramsOfSelectedTemplate?.map((item, index) => {
            return (
              <>
                <FormControl fullWidth sx={{ mt: index === 0 ? 0 : 2 }}>
                  <TextField
                    label={`${item}`}
                    // labelId="demo-simple-select-label"
                    // id="demo-simple-select"
                    placeholder={`Select ${item}`}
                    name={item}
                    // value={selectedColumn[item]}
                    onChange={handleChange}
                    displayEmpty
                    fullWidth
                  // disabled={!selectedSheet}
                  >
                    {/* <MenuItem value="" disabled>
                                  Select {item}
                                </MenuItem> */}
                    {/* {columns?.map((column) => (
                      <MenuItem key={column} value={column}>
                        {column}
                      </MenuItem>
                    ))} */}
                  </TextField>
                </FormControl>
              </>
            );
          })}
          {/* Submit Button */}
          <Button variant="contained" onClick={handleSubmitModal} sx={{ mt: 3 }} disabled={isButtonDisabled}>
            Submit
          </Button>
        </Box>
      </Modal>
    </Stack>
  );
};

export default TestUserModal;
